import { RouterProvider } from 'react-router-dom';
import { router } from './routes';

/**
 * App shell — only owns routing.
 * Theme/lang state lives on document attributes so it survives route transitions
 * without React Context churn.
 */
export default function App() {
  return <RouterProvider router={router} />;
}
